module.exports = __webpack_public_path__ + "static/img/download_back3.d9d042c5.png";